"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const WebHIDHeadsets_model_1 = require("xchelper/models/WebHIDHeadsets.model");
class WebHIDHeadsetService {
    constructor($window, $log, $rootScope, XucPhoneEventListener, CtiProxy, electronWrapper, applicationConfiguration, XucPhoneState, ExternalEvent) {
        this.$window = $window;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.XucPhoneEventListener = XucPhoneEventListener;
        this.CtiProxy = CtiProxy;
        this.electronWrapper = electronWrapper;
        this.applicationConfiguration = applicationConfiguration;
        this.XucPhoneState = XucPhoneState;
        this.ExternalEvent = ExternalEvent;
        this.singlePageDescription = true;
        this.states = [];
        this.previousState = undefined;
        this.fillStatesArray = () => {
            [
                this.HID_RINGING,
                this.HID_OFFHOOK,
                this.HID_ONHOLD
            ].forEach(state => {
                let output = this.createOutput(state);
                if (output)
                    this.states.push({ id: output.reportId, key: state });
            });
        };
        this.disablePreviousState = (previousState) => {
            var _a;
            this.$log.debug(`HID - Disabling previous state ${this.keyToState(previousState.key)}`);
            this.electronWrapper.isElectron() ?
                this.electronWrapper.sendReport(previousState.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(previousState.id, new Uint8Array([0]));
            this.previousState = undefined;
        };
        this.resetState = () => {
            var _a;
            this.$log.debug(`HID - Reset all states`);
            if (!this.singlePageDescription) {
                this.states.forEach(state => {
                    var _a;
                    this.electronWrapper.isElectron() ?
                        this.electronWrapper.sendReport(state.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(state.id, new Uint8Array([0]));
                });
            }
            else {
                let state = this.states[0];
                this.electronWrapper.isElectron() ?
                    this.electronWrapper.sendReport(state.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(state.id, new Uint8Array([0]));
            }
            this.previousState = undefined;
            this.setHeadsetState(this.HID_ONLINE);
        };
        this.setupDevice = (device) => {
            var _a;
            this.headsetModel = device.vendorId;
            this.headsetName = device.productName;
            this.$rootScope.$broadcast(this.ExternalEvent.WEBHID_DEVICE_SELECTED, this.headsetName);
            this.telephonyOutputReport = this.getTelephonyOutputReport((_a = this.device) === null || _a === void 0 ? void 0 : _a.collections);
            if (this.telephonyOutputReport)
                this.singlePageDescription = this.telephonyOutputReport.length == 1;
            this.setInputListener(device);
            this.setPhoneEventsListeners();
            this.fillStatesArray();
            this.resetState();
        };
        this.processEvent = (eventCode, reportId, electronReport) => {
            let report = electronReport || this.getWebReports(reportId);
            let bits = (eventCode).toString(2).split("").reverse();
            report === null || report === void 0 ? void 0 : report.items.forEach((item, index) => {
                var _a;
                let matchingBit = bits.length > index ? bits[index] : "0";
                (_a = item.usages) === null || _a === void 0 ? void 0 : _a.forEach(usage => {
                    this.executeMatchingAction(usage, matchingBit);
                });
            });
        };
        this.getWebReports = (reportId) => {
            var _a;
            let reports = (_a = this.device) === null || _a === void 0 ? void 0 : _a.collections.flatMap(col => col.inputReports).find(report => report.reportId === reportId);
            return reports;
        };
        this.getTelephonyOutputReport = (collections) => {
            var _a;
            return (_a = collections === null || collections === void 0 ? void 0 : collections.find(c => c.usagePage == 0x0B)) === null || _a === void 0 ? void 0 : _a.outputReports;
        };
        this.executeMatchingAction = (usage, bit) => {
            const actions = {
                "B20": () => this.handleHookSwitch(bit)
            };
            const actionKey = this.toHIDCode(usage).join("");
            if (actions[actionKey])
                actions[actionKey]();
        };
        this.handleHookSwitch = (bit) => {
            this.$log.debug(`HID - Received HOOKSWITCH with value ${bit}`);
            let calls = this.XucPhoneState.getCallsWithStates();
            let isAnswerCmd = parseInt(bit) == 1;
            if (calls.length == 1)
                this.singleCallScenario(this.XucPhoneState.getState(), isAnswerCmd);
        };
        this.singleCallScenario = (lineState, isAnswerCmd) => {
            this.$log.debug(`HID - LineState ${lineState} bit ${isAnswerCmd}`);
            if (isAnswerCmd) {
                if (this.XucPhoneState.isPhoneRinging(lineState))
                    this.CtiProxy.answer();
                else if (this.XucPhoneState.isOnHold())
                    this.CtiProxy.hold();
            }
            else {
                if (this.XucPhoneState.isPhoneOffHook(lineState))
                    this.CtiProxy.hangup();
            }
        };
        this.handlePhoneEventWithContext = () => {
            let calls = this.XucPhoneState.getCalls();
            if (calls.length == 0)
                this.resetState();
            else if (calls.length == 1)
                this.setHeadsetStateWithSingleCall(calls[0]);
        };
        this.setHeadsetStateWithSingleCall = (call) => {
            switch (call.state) {
                case this.XucPhoneState.STATE_ESTABLISHED:
                    this.setHeadsetState(this.HID_OFFHOOK);
                    break;
                case this.XucPhoneState.STATE_DIALING:
                    this.setHeadsetState(this.HID_OFFHOOK);
                    break;
                case this.XucPhoneState.STATE_RINGING:
                    this.setHeadsetState(this.HID_RINGING);
                    break;
                case this.XucPhoneState.STATE_ONHOLD:
                    this.setHeadsetState(this.HID_ONHOLD);
                    break;
            }
        };
        this.setHeadsetState = (key) => {
            var _a, _b;
            let output = this.createOutput(key);
            if (output && output.reportId != ((_a = this.previousState) === null || _a === void 0 ? void 0 : _a.id)) {
                if (!this.singlePageDescription && this.previousState)
                    this.disablePreviousState(this.previousState);
                this.$log.debug(`HID - Enabling device state ${this.keyToState(key)}`);
                this.electronWrapper.isElectron() ?
                    this.electronWrapper.sendReport(output.reportId, output.data) : (_b = this.device) === null || _b === void 0 ? void 0 : _b.sendReport(output.reportId, output.data);
                if (!this.singlePageDescription && key != this.HID_ONLINE)
                    this.previousState = { id: output.reportId, key: key };
            }
            ;
        };
        this.toHIDCode = (action) => {
            let decoded = action
                .toString(16)
                .toUpperCase();
            let usage = decoded.slice(-2);
            let page = decoded.slice(0, -4);
            return [page, usage];
        };
        this.keyToState = (key) => {
            let state = "UNKNOWN";
            switch (key) {
                case (this.HID_ONLINE):
                    state = "AVAILABLE";
                    break;
                case (this.HID_OFFHOOK):
                    state = "OFFHOOK";
                    break;
                case (this.HID_RINGING):
                    state = "RINGING";
                    break;
                case (this.HID_ONHOLD):
                    state = "ONHOLD";
                    break;
            }
            return state;
        };
        this.createOutput = (hex) => {
            const { reportInfo, reportItem, itemIndex } = this.getMatchingReportData(hex, this.telephonyOutputReport);
            if (reportInfo && reportItem && itemIndex !== undefined) {
                return { reportId: reportInfo.reportId, data: new Uint8Array([1 << itemIndex]) };
            }
        };
        this.HID_ONLINE = "8002A";
        this.HID_RINGING = "80018";
        this.HID_OFFHOOK = "80017";
        this.HID_ONHOLD = "80020";
        this.getCurrentDeviceName = () => {
            return this.headsetName;
        };
        this.setCurrentDeviceName = (_, name) => {
            return this.headsetName = name;
        };
        this.$log.info("HID - Starting webHID headset service");
        this.headsetProvider = new WebHIDHeadsets_model_1.HeadsetsProvider(this.applicationConfiguration);
        this.$rootScope.$on(this.ExternalEvent.WEBHID_INPUT_TYPE, this.processElectronHIDInput.bind(this));
        this.$rootScope.$on(this.ExternalEvent.WEBHID_LED_OUTPUTS_REPORTS, this.processElectronReports.bind(this));
        this.$rootScope.$on(this.ExternalEvent.WEBHID_DEVICE_SELECTED, this.setCurrentDeviceName.bind(this));
        if (this.electronWrapper.isElectron())
            this.electronWrapper.HIDServiceReady();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            let filters = this.headsetProvider.getSupportedVendors();
            this.electronWrapper.isElectron() ? this.electronHandler(filters) : this.webHandler(filters);
        });
    }
    processElectronReports(_, data) {
        this.telephonyOutputReport = this.getTelephonyOutputReport(JSON.parse(data).collections);
        if (this.telephonyOutputReport)
            this.singlePageDescription = this.telephonyOutputReport.length == 1;
        this.fillStatesArray();
        this.resetState();
        this.setPhoneEventsListeners();
    }
    setInputListener(device) {
        device.addEventListener('inputreport', (e) => {
            const { data, reportId } = e;
            let eventCode;
            if (data.buffer) {
                let uia = new Uint8Array(data.buffer);
                eventCode = uia[0];
            }
            else
                eventCode = data.getUint8(0);
            this.processEvent(eventCode, reportId);
        });
    }
    electronHandler(filters) {
        this.electronWrapper.requestWebHID(filters);
    }
    processElectronHIDInput(_, data) {
        this.$log.debug("HID - Received external HID input", data);
        this.headsetModel = this.headsetProvider.getHeadsetModelByVendorID(data.vendorId);
        if (this.headsetModel) {
            this.processEvent(data.code, data.reportId, data.report);
        }
        else
            this.$log.warn(`HID - This device is not supported for webHID`);
    }
    webHandler(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            filters = filters.map(filter => { return { vendorId: filter }; });
            try {
                let [device] = yield this.$window.navigator.hid.requestDevice({ filters });
                if (device) {
                    this.headsetModel = this.headsetProvider.getHeadsetModelByVendorID(device.vendorId);
                    if (this.headsetModel) {
                        yield this.openDevice(device);
                        this.$window.localStorage.setItem("HID_DEVICE", JSON.stringify({ vendorId: device.vendorId, productId: device.productId }));
                    }
                    else
                        this.$log.warn(`HID - This device is not supported for webHID: ${device.productName}`);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    setPhoneEventsListeners() {
        this.XucPhoneEventListener.addDialingHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addRingingHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addEstablishedHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addReleasedHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addOnHoldHandler(this.$rootScope, this.handlePhoneEventWithContext);
    }
    getMatchingReportData(hex, telephonyOutputReport) {
        let targetUsage = parseInt(hex, 16);
        for (let reportInfo of telephonyOutputReport || []) {
            let itemIndex = reportInfo.items.findIndex(item => item.usages.includes(targetUsage));
            let reportItem = itemIndex !== -1 ? reportInfo.items[itemIndex] : undefined;
            if (reportItem) {
                return { reportInfo, reportItem, itemIndex };
            }
        }
        return {};
    }
    getDeviceFromBrowser(device) {
        return this.$window.navigator.hid.getDevices().then((devices) => {
            return devices.find((d) => d.vendorId == device.vendorId && d.productId == device.productId);
        });
    }
    openDevice(device) {
        return __awaiter(this, void 0, void 0, function* () {
            if (device) {
                try {
                    yield device.open();
                    this.device = device;
                    this.setupDevice(device);
                }
                catch (e) {
                    this.$log.warn(`HID - Could not open WebHID device ${device.productName}`);
                    this.$log.debug("HID - Reason :", e);
                }
            }
        });
    }
    uninit() {
        if (this.electronWrapper.isElectron())
            this.electronWrapper.uninitWebHID();
        else if (this.device) {
            this.resetState();
            this.device.close();
            this.device = undefined;
            this.headsetModel = undefined;
            this.headsetName = undefined;
            this.$window.localStorage.removeItem("HID_DEVICE");
            this.$rootScope.$broadcast(this.ExternalEvent.WEBHID_DEVICE_SELECTED, undefined);
        }
    }
}
exports.default = WebHIDHeadsetService;
WebHIDHeadsetService.$inject = ["$window", "$log", "$rootScope", "XucPhoneEventListener", "CtiProxy", "electronWrapper", "applicationConfiguration", "XucPhoneState", "ExternalEvent"];
